import {
  Box,
  Button,
  FormControlLabel,
  Popover,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { EProductType } from "model";
import React from "react";
import { PRODUCT_TYPE } from "common";
import { StringHelper } from "helpers";
import { I18nTranslator, translations } from "utils/i18n";

interface IFilterPopupProps {
  currentType?: {
    type?: EProductType;
    hasQrCode?: boolean;
    isActive?: boolean;
  };
  anchor: HTMLButtonElement | null;
  onClose(): void;
  onSave(callback: {
    value?: EProductType;
    hasQRCode?: boolean;
    isActive?: boolean;
  }): void;
}

enum IQRType {
  ALL = "A",
  QR = "QR",
  NO_QR = "NoQR",
}

export const QUANTITY_TYPE = [
  {
    type: IQRType.ALL,
    name: translations.type.allType,
  },
  {
    type: IQRType.QR,
    name: translations.type.qr,
  },
  {
    type: IQRType.NO_QR,
    name: translations.type.noQR,
  },
];

const FilterPopup = (props: IFilterPopupProps) => {
  const { anchor, currentType, onClose, onSave } = props;
  const open = Boolean(anchor);
  const [value, setValue] = React.useState<EProductType | undefined>(
    currentType?.type
  );
  const [hasQRCode, setHasQRCode] = React.useState<boolean | any>(
    currentType?.hasQrCode
  );
  const [isActive, setIsActive] = React.useState<boolean | any>(
    currentType?.isActive
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value as EProductType);
  };
  const handleSave = () => {
    onSave({ value, hasQRCode, isActive });
    onClose();
  };
  return (
    <Popover
      id={"filter"}
      open={open}
      anchorEl={anchor}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Box sx={{ width: 500 }} p={2}>
        <Typography fontWeight={"bold"} variant={"h3"}>
          {I18nTranslator(translations.masterData.filter)}
        </Typography>
        <Box sx={{ marginBottom: "20px", marginTop: "20px" }}>
          <Typography fontWeight={"bold"} variant={"h4"}>
            {I18nTranslator(translations.masterData.productType)}
          </Typography>
          <RadioGroup
            defaultValue={value}
            style={{ display: "flex", flexDirection: "row" }}
          >
            {PRODUCT_TYPE.map((type) => {
              return (
                <FormControlLabel
                  key={type.name}
                  control={<Radio onChange={handleChange} />}
                  label={StringHelper.getProductTypeName(type.type)}
                  value={type.type}
                />
              );
            })}
          </RadioGroup>
        </Box>
        <Box sx={{ marginBottom: "20px", marginTop: "20px" }}>
          <Typography fontWeight={"bold"} variant={"h4"}>
            {I18nTranslator(translations.receive.qrCode)}
          </Typography>
          <RadioGroup
            defaultValue={hasQRCode}
            style={{ display: "flex", flexDirection: "row" }}
          >
            <FormControlLabel
              key={"all"}
              control={<Radio onChange={() => setHasQRCode("A")} />}
              label={I18nTranslator(translations.receive.all)}
              value={"A"}
            />
            <FormControlLabel
              key={"qr"}
              control={<Radio onChange={() => setHasQRCode(true)} />}
              label={I18nTranslator(translations.receive.qrCode)}
              value={true}
            />
            <FormControlLabel
              key={"noQR"}
              control={<Radio onChange={() => setHasQRCode(false)} />}
              label={I18nTranslator(translations.receive.noQRCode)}
              value={false}
            />
          </RadioGroup>
        </Box>
        <Box sx={{ marginBottom: "20px", marginTop: "20px" }}>
          <Typography fontWeight={"bold"} variant={"h4"}>
            {I18nTranslator(translations.receive.status)}
          </Typography>
          <RadioGroup
            defaultValue={isActive}
            style={{ display: "flex", flexDirection: "row" }}
          >
            <FormControlLabel
              key={"all"}
              control={<Radio onChange={() => setIsActive("A")} />}
              label={I18nTranslator(translations.receive.all)}
              value={"A"}
            />
            <FormControlLabel
              key={"qr"}
              control={<Radio onChange={() => setIsActive(true)} />}
              label={I18nTranslator(translations.masterData.active)}
              value={true}
            />
            <FormControlLabel
              key={"noQR"}
              control={<Radio onChange={() => setIsActive(false)} />}
              label={I18nTranslator(translations.masterData.inactive)}
              value={false}
            />
          </RadioGroup>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button variant="contained" onClick={handleSave}>
            {I18nTranslator(translations.button.save)}
          </Button>
        </Box>
      </Box>
    </Popover>
  );
};

export default FilterPopup;
